import ChkIcon from '../../../../../resources/common/chk.svg';
import ChkOnIcon from '../../../../../resources/common/chk_on.svg';

const TypeAstyle = `
    body.modal-open{padding-right: 0px !important;}
    /*=========콘솔페이지 메인 상단============*/
    .m_detail_content { display: none;}
    .attend_box{
      display:flex; 
      justify-content:space-between; 
      width: 100%;
      background:#12A884; 
      padding:4px 12px 4px 0; 
      gap:20px;
      position:fixed;
      top: 60px;
      z-index: 1001;
    }
    .marquee_box {
      overflow: hidden;
      position: relative;
      width:calc(100% - 70px);
    }

    .marquee_box span {
      position: absolute;
      top: 0;
      right: 0;
      width: 65px;
      height: 100%;
      background: linear-gradient(to right,rgba(18,168,132,0.00) 0%, #12A884 100%);
      z-index:1;
    }
    .marquee_box .marquee .rfm-marquee .rfm-child{
      font-size:12px; 
      font-weight:400; 
      line-height:18px; 
      color:#fff;
    }
    .attend_box button{position:relative; font-size:12px; font-weight:500; line-height:16px; color:#fff; margin-bottom:1px; padding-bottom:1px;}
    .attend_box button:after{content:''; width:100%; height:1px; background:#fff; position:absolute; bottom:0px; left:0;}

    .detail_header_bnr {
      position: absolute;
      top:86px;
      left: 50%;
      transform:translateX(-50%);
      width: 100%;
      height: auto;
      max-width:1920px;
      max-height:1080px;
      margin: 0 auto;
      box-sizing: border-box;
    }
    .detail_header_bnr img { display: block; width: 100%; height: 100%; max-height: inherit;}
    .detail_con {
      padding: 0 20px;
      margin-bottom: 100px;
      width: 100%;
      height: auto;
      background: #fff;
      box-sizing:border-box;
    }
    .sub_bg_img_hd {
      position: relative;
      display: block;
      width: 100%;
      max-width: 1180px;
      height: auto;
      max-height:170px;
      margin: 0px auto 0;
      z-index: 99;
    }
    .sub_bg_img_hd a { display: block;  width: 100%;  height: 100%;}
    .sub_bg_img_hd img { display: block; width: 100%; max-height: 170px;}
    .video_con {
      border-radius:6px;
      overflow:hidden;
      margin:0 auto;
    }
    .video_con.css-fullscreen {
      position: fixed;
      top: 0 !important;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9998;
      background: #000;
      border-radius: 0;
      padding: 0;
      margin: 0;
      max-width: none;
      display: grid;
      place-items: center;
    }
    body.css-fullscreen-active #header,
    body.css-fullscreen-active .header,
    body.css-fullscreen-active .header-freeze,
    body.css-fullscreen-active .m_header_wrap,
    body.css-fullscreen-active .attend_box,
    body.css-fullscreen-active .detail_header_bnr,
    body.css-fullscreen-active .sub_bg_img_hd,
    body.css-fullscreen-active #footer > .footer-arrow-wrap,
    body.css-fullscreen-active #footer > .footer_inform_cont,
    body.css-fullscreen-active #footer > .footer {
      display: none !important;
    }
    body.css-fullscreen-active .detail_left_box_top,
    body.css-fullscreen-active .card-title-position {
      display: none !important;
    }
    body.css-fullscreen-active .survey_container.modal {
      z-index: 10001 !important;
    }
    body.css-fullscreen-active .consolePopup_container.modal {
      z-index: 10001 !important;
    }
    body.css-fullscreen-active .modal-backdrop {
      z-index: 10000 !important;
    }
    .video_pre_con {
      position: relative;
      width: 100%;
      height: 100%;
      max-width: 1180px;
      text-align: center;
      margin: 0 auto;
      background: #000;
      border-radius: 6px;
      overflow: hidden;
      padding-top: 56.25%;
    }
    .video_pre_con img.player_default_img { width: 100%;}
    .video_element { position: relative; max-width: 1180px; width: 100%; height: auto;}
    .video_con.css-fullscreen .video_pre_con { display: none; }
    .video_con.css-fullscreen .video_element {
      position: relative;
      inset: auto;
      width: min(100vw, calc(100vh * 16 / 9));
      height: auto;
      max-width: none;
      display: block;
    }
    .video_element .video-wrap { height: 100%; }
    .video_con.css-fullscreen .video-wrap,
    .video_con.css-fullscreen .video_element .video-wrap,
    .video_con.css-fullscreen .react-jw-player-container {
      width: 100%;
      height: auto;
      overflow: hidden;
    }
    .video_con .video_info { display: none;}
    .video_con.css-fullscreen .video_info { display: none; }
    .video_dummy {
      display: none;
      width: 100%;
      height: 664px;
      border-radius: 6px;
      background: transparent;
    }
    .video_dummy.on { display: block; }
    @keyframes topin {from { top: -115px;} to { top: 60px; }}
    @keyframes attendanceTopin {from { top: -115px;} to { top: 86px; }}
    @keyframes topin_767 { from { top: -115px;} to { top: 0px; }}
    .video_con.fixed {
      position: fixed;
      left: 0;
      display: flex;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      width: 100%;
      max-width: 100%;
      background: #fff;
      z-index: 1000;
      margin-top: 0;
      border-bottom: 1px solid #ccc;
      animation-duration: 0.3s;
      animation-name: topin;
      animation-fill-mode: forwards;
      animation-timing-function: ease;
      border-radius: 0;
    }
    .video_con.attedanceFixed{
      animation-duration: 0.3s;
      animation-name: attendanceTopin;
      animation-fill-mode: forwards;
      animation-timing-function: ease;
    }
    .video_con.fixed .video_element { width: 200px; height: 110px; margin-right: 20px; }
    .video_con.fixed .video_element .video-frame { height: 100%;}
    .video_con.fixed .video_element .video-frame video { height: 100% !important;}
    .video_con.fixed .jw-error-msg { width: 90%; }
    .video_con.fixed .jw-error .jw-error-msg .jw-icon,
    .video_con.fixed .jwplayer.jw-state-error .jw-error-msg .jw-icon { width: 20px; height: 20px; margin-bottom: 10px;}
    .video_con.fixed #VYgkaoeG .jw-error-text {font-size: 8px;}
    .video_con.fixed .jw-display-icon-container .jw-icon{ width: 40px; height: 40px; line-height: 40px; }
    .video_con.m_fixed .jw-display-icon-container .jw-icon{ width: 24px;  height: 24px; line-height: 24px; }
    .jw-wrapper{background-color:transparent !important;}
    .jw-preview,.jw-controls-backdrop{border-radius:6px;}
    .jw-overlays{ background-color: rgba(0,0,0,0.1) !important;}
    .jw-display-icon-container .jw-icon{ background: rgba(0,0,0,0.7); border-radius: 50%; padding: 10px;}
    /* JW Player 자체 전체화면 버튼 숨김. Samsung Internet 등 일부 브라우저에서 단일 selector만으로
       숨김이 안 먹는 케이스가 있어 변형 클래스/aria-label 까지 모두 매칭하고, 강력한 속성을 함께 적용. */
    .jw-icon-fullscreen,
    .jw-fullscreen-ima,
    .jwplayer [aria-label="전체 화면"],
    .jwplayer [aria-label="Fullscreen"],
    .jwplayer .jw-svg-icon-fullscreen-off,
    .jwplayer .jw-svg-icon-fullscreen-on {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    /* CSS fullscreen 시 root 스크롤(html) + body 스크롤 모두 차단. body만으로는
       브라우저 root 스크롤(html)을 막지 못해 우측 스크롤바가 그대로 보이는 회귀를 차단. */
    body.css-fullscreen-active { overflow: hidden; }
    html.css-fullscreen-active { overflow: hidden !important; }
    /* native fullscreen 케이스(documentElement.requestFullscreen)도 함께 처리 */
    html:fullscreen,
    html:-webkit-full-screen,
    html:-moz-full-screen { overflow: hidden !important; }
    :fullscreen body,
    :-webkit-full-screen body,
    :-moz-full-screen body { overflow: hidden !important; }
    /* 터치 디바이스(모바일/태블릿)에선 page-level 스크롤이 살아 있어야 iOS Safari가
       사용자 swipe를 인식해 url 바를 자동으로 숨길 수 있어 위 overflow:hidden을 해제한다.
       max-width 기준만 쓰면 모바일 가로 모드(iPhone landscape ≈ 844px)에선 매칭이 안 돼
       PC 분기를 타므로, (hover: none) and (pointer: coarse)로 터치 디바이스 자체를 매칭한다.
       시각적으로는 .video_con.css-fullscreen이 fixed로 viewport 전체를 덮어 안전. */
    @media (max-width: 767px), (hover: none) and (pointer: coarse) {
      body.css-fullscreen-active { overflow: visible !important; }
      html.css-fullscreen-active { overflow: visible !important; }
    }
    /* fullscreen 모드에서 JW Player 슬라이더(시간/볼륨)와 그 자식 영역의 touch가
       page scroll로 전달되어 iOS Safari url 바가 재표시되는 회귀를 차단.
       슬라이더 자체의 드래그 핸들러는 element 레벨이라 정상 동작. */
    .video_con.css-fullscreen .jw-slider-time,
    .video_con.css-fullscreen .jw-slider-time *,
    .video_con.css-fullscreen .jw-slider-volume,
    .video_con.css-fullscreen .jw-slider-volume *,
    .video_con.css-fullscreen .jw-knob,
    .video_con.css-fullscreen .jw-controlbar {
      touch-action: none;
    }
    /* native fullscreen 케이스(documentElement.requestFullscreen)도 함께 처리 */
    html:fullscreen,
    html:-webkit-full-screen,
    html:-moz-full-screen { overflow: hidden !important; }
    :fullscreen body,
    :-webkit-full-screen body,
    :-moz-full-screen body { overflow: hidden !important; }
    .css-fullscreen-btn {
      position: absolute;
      right: 10px;
      /* 컨트롤바 위쪽으로 띄워 JW Player의 설정/풀스크린 버튼과 클릭 영역이 겹치지 않게 한다. */
      bottom: 44px;
      z-index: 9999;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 18px;
      background: rgba(0,0,0,0.6);
      border: none;
      border-radius: 4px;
      cursor: pointer;
      opacity: 0;
      pointer-events: none;
      transition: background 0.2s, opacity 0.2s;
    }
    .css-fullscreen-survey-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 9999;
      min-width: 92px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 14px;
      color: #fff;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.04em;
      background: rgba(0,0,0,0.6);
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background 0.2s;
    }
    .css-fullscreen-btn:hover { background: rgba(0,0,0,0.8); }
    .css-fullscreen-survey-btn:hover { background: rgba(0,0,0,0.8); }
    .react-jw-player-container:hover .css-fullscreen-btn {
      opacity: 1;
      pointer-events: auto;
    }
    .video_con.css-fullscreen .css-fullscreen-survey-btn {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
    }
    .video_con.css-fullscreen .css-fullscreen-btn {
      position: fixed;
      right: 20px;
      /* JW Player 컨트롤바(설정/해상도 등)와 클릭 영역 충돌 방지 — 컨트롤바 위로 띄움 */
      bottom: 60px;
      z-index: 9999;
      opacity: 0;
      pointer-events: none;
    }
    .video_con.css-fullscreen .css-fullscreen-btn.is-visible {
      opacity: 1;
      pointer-events: auto;
    }
    .video_con.fixed .video_info { width: calc(100% - 220px); display: block;color: #333; font-weight: bold; }
    .video_con .video_info h4 {
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .video_con .video_info h4 span { color: #333; font-weight: normal; }
    .video_con .video_info p {
      font-size: 20px;
      overflow: hidden;
      line-height: initial;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      font-weight: bold;
    }
    @media (max-width: 767px) and (orientation: portrait) {
      .video_con.fixed{animation-name:topin_767}
      .jw-preview,.jw-controls-backdrop{border-radius:0px;}
    }
    /*=========콘솔페이지 메인 상단 끝============*/

    /*=========콘솔페이지 메인 중앙 왼쪽============*/
    .detail_flex_box { display: flex;}
    .detail_left_box {
      width: calc(100% - 300px);
      padding-right: 30px;
      box-sizing: border-box;
      z-index:999;
      padding-top:30px;
    }
    .detail_left_box_top .service_type_box { position: relative; display: flex; justify-content: space-between; align-items: flex-start;}
    .detail_left_box_top .service_type_box .service_type_box_div{ font-size:0; padding-right:50px;}
    .detail_left_box_top .service_type_box .live_time {
      display: inline-block;
      font-size: 15px;
      text-align: left;
      color: #333333;
      line-height: 24px;
      vertical-align:top;
    }
    .detail_left_box_top > p {
      font-size: 20px;
      margin: 10px 0 20px;
      font-weight: bold;
      text-align: left;
      line-height: 1.5;
      color: #333333;
      word-break: break-word;
    }
    .detail_left_box_top .more_btn_span {
      display: inline-block;
      height: 24px;
      font-size: 15px;
      font-weight: 500;
      line-height: 1.43;
      color: #999999;
      cursor: pointer;
    }
    .detail_left_box_top .more_btn_span img { display: block;}
    .detail_left_box_top .more_btn_span small { text-decoration: underline; height: inherit;}
    .detail_left_box_top .tooltip_con {
      position: absolute;
      top: 30px;
      right: 0;
      width: 135px;
      height: auto;
      border-radius: 4px;
      box-shadow: 3px 3px 10px 0 rgba(0, 0, 0, 0.24);
      border: solid 2px #4e4b7b;
      background: #fff;
      z-index: 999;
    }
    .detail_left_box_top .tooltip_con li a { display: block;font-weight: 500; line-height: 1.63; color: #333333; padding: 8px 10px; cursor: pointer;}
    .detail_left_box_top .tooltip_con li a:hover { background-color: #e7e7f9;}
    .detail_left_box_top .tooltip_background { position: fixed; top: 0; left: 0; z-index: 998; width:100%; height:100%;}
    /*=========콘솔페이지 메인 중앙 왼쪽 끝============*/

    /*=========콘솔페이지 메인 중앙 왼쪽 사용자============*/
    .m_slide_con { display: none;}
    .slide_con { position: static; display: block;}
    .slide_con .swiper-container { padding-bottom: 30px; margin-bottom: 30px; }
    .detail_left_box_top_inner { margin-bottom: 30px; }
    .slide_con_flex:after { content: ""; display: block; clear: both;}
    .slide_con_flex .slide_flex { width: 100%; float: left; margin-right: 20px;}
    .slide_con_flex .slide_flex:last-child { margin-right: 0;}
    .slide_flex { width: 100%; display: flex; align-items:flex-start; cursor: pointer;}
    .slide_con_1 .slide_flex .slide_flex_t { width: 100%;}
    .swiper-container .slide_flex { margin-right: 0;}
    .slide_flex .slide_flex_div { position: relative; width: 58px; height: 58px; margin-right: 10px;}
    .slide_flex .slide_flex_inner_div { position: relative;width: inherit; height: inherit;}
    .slide_flex .slide_img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color:#D0D0DE;
      overflow: hidden;
      border-radius: 50%;
    }
    .slide_flex .slide_img_more {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 19px;
      height: 19px;
      background-size:cover;
      background-position:center center;
    }
    .slide_flex .slide_flex_t div { display: flex; justify-content: flex-start; margin-bottom: 5px;}
    .slide_flex .slide_flex_t h2 {
      text-align: left;
      color: #464F60;
      font-weight: 700;
      margin: 2px 0;
      line-height:20px;
    }
    .slide_flex .slide_flex_t b {
      font-size: 11px;
      display: block;
      line-height: 14px;
      font-weight: 400;
      color: #464f60;
    }
    .slide_flex .slide_flex_t p {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      row-gap: 3px;
      font-size: 11px;
      text-align: left;
      line-height: 14px;
      color: #464F60;
      word-break:break-word;
    }
    .slide_flex_t p span {font-size: 11px; display: inline-block;}
    .slide_con .swiper-pagination { bottom: 0; width:100%;}
    .slide_con .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .slide_con .swiper-pagination-bullet-active {  background: #373779;}
    /*=========콘솔페이지 메인 중앙 왼쪽 사용자 끝============*/
    
    /*=========콘솔페이지 메인 중앙 오른쪽============*/
    .detail_right_box {width: 300px; z-index:998; padding-top:30px;}
    .detail_banner_box_con{margin-bottom:30px}
    .detail_banner_box_con .right_banner_box {
      width: 100%;
      height: auto;
      border-radius: 6px;
      overflow: hidden;
    }
    .detail_banner_box_con .right_banner_box a { display: block; width: 100%; height: 100%; cursor: pointer;}
    .detail_banner_box_con .right_banner_box a img { display: block; width: 100%; height: 100%;}
    /*=========콘솔페이지 메인 중앙 오른쪽 끝============*/
    
    /*==============QnA=============*/
    .qna_container { display: block;}
    .qna_container .question_write_box { background: #f7f7fa; padding: 20px; box-sizing: border-box; border-radius: 6px;}
    .qna_container .question_write_box .question_write_box_inner { position: relative; margin-bottom: 15px; display: flex;}
    .qna_container .question_write_box .question_write_box_inner h2 {font-size: 20px; color: #333; font-weight: bold;}
    .qna_container .question_write_box .question_write_box_inner span {
      display: inline-block;
      font-size: 11px;
      line-height: 2;
      text-align: right;
      color: #999999;
      font-weight: normal;
      margin-left: 10px;
    }
    .qna_container .question_write_box .question_box_flex { display: flex; justify-content: space-between; align-items: center;}
    .qna_container .question_write_box textarea {
      display: block;
      resize: none;
      width: calc(100% - 90px);
      border: none;
      background: none;
      background: #f7f7fa;
      font-family: "Noto Sans KR",sans-serif;
      color: #666;
      font-size: 15px;
      padding: 10px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ccc;
      outline:none;
    }
    .qna_container .question_write_box textarea::placeholder { font-size: 15px; color: #cccccc;}
    .qna_container .question_write_box button {
      width: 80px;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      background: #7878a5;
      color: #fff;
      border-radius: 4px;
    }
    .question_list_box { padding: 30px 0; box-sizing: border-box;}
    .question_list_box_title { display: flex; justify-content: space-between; padding-left: 20px; margin-bottom: 30px; line-height: 24px;}
    .question_list_box .question_list_box_title ul { display: flex;}
    .question_list_box_title li a { color: #ccc; line-height: 1.85; cursor: pointer;}
    .question_list_box_title li a:hover { color: #111;}
    .question_list_box_title li a:after {
      content: "";
      display: inline-block;
      width: 1px;
      height: 12px;
      margin: 0 10px;
      background: #ccc;
    }
    .question_list_box_title li:last-child a:after { content: none;}
    .question_list_box_title li.on a { color: #111; }
    .question_list_box_title p { font-size:12px; color: #888888;}
    .question_list_box_title p b { font-size:12px; display: inline-block; color: #888888; font-weight:normal;}
    .question_list_inner_box:first-child .question_list_box_desc { padding-top: 0;}
    .question_list_inner_box { margin-left: 20px; border-bottom: 1px solid #ebebeb;}
    .question_list_box_desc { padding: 15px 0px;}
    .question_list_inner_box:last-child { border-bottom: 0;}
    .question_list_inner_box.on { background: #ebebeb;}
    .comment_list_box { display: flex;margin-bottom: 9px; align-items: flex-start; margin-left: 25px;}
    .comment_list_box .question_list_box_desc_btn .reply_del_btn { margin-left: 0;}
    .question_list_inner_box .comment_list_box:first-child { margin-top: 16px; }
    .comment_list__inner_box.on,
    .question_list_box_desc.on,
    .comment_list_box.on { background: #ebebeb; }
    .question_list_box_desc pre,
    .comment_list_box pre {
      font-family: "Noto Sans KR", sans-serif;
      line-height: 1.43;
      color: #333333;
      font-weight: normal;
      width: 100%;
      word-break: break-word;
      white-space: break-spaces;
      overflow:unset;
    }
    .comment_list_box .reply_btn { display: none;}
    .ad_question_morebtn {
      display: block;
      position: absolute;
      top: 20px;
      right: 20px;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
    .question_list_box_desc .question_list_box_date_reply_span,
    .comment_list_box .question_list_box_date_reply_span { font-size: 11px; line-height: 1.45; color: #999999;}
    .question_list_box_desc_btn { display: flex; align-items: center; margin-top: 7px;}
    .question_list_box_desc_btn button { display: flex; align-items: center; padding: 0; margin-left: 10px;}
    .question_list_box_desc_btn button:first-child { margin-left: 0;}
    .question_list_box_desc_btn span { color: #4e4b7b;}
    .question_list_box_desc_btn img { vertical-align: middle;}
    .question_list_box_desc_btn small {
      display: inline-block;
      margin-right: 5px;
      height: 22.5px;
      text-align: left;
      color: #4e4b7b;
    }
    .question_list_box_desc_btn b { display: inline-block; font-size: 15px; height: 22.5px; color: #4e4b7b;}
    .admin_question_list_wrapper_box .question_list_inner_box {
      border: 1px solid #ebebeb;
      padding: 0px;
      box-sizing: border-box;
      border-radius: 6px;
      margin-bottom: 10px;
      margin-left: 0;
    }
    .admin_question_list_wrapper_box .question_list_box_desc { border-radius: 0; padding: 18px 20px;}
    .admin_question_list_wrapper_box .question_list_inner_box:first-child .question_list_box_desc { padding-top: 20px;}
    .admin_question_list_wrapper_box .question_list_box_desc .question_list_box_date_reply { padding-bottom: 0; border-bottom: 0;}
    .admin_question_list_wrapper_box .comment_list_box { padding: 7px 20px 7px; margin-bottom: 0; margin-left: 0; padding-left: 50px; }
    .admin_question_list_wrapper_box .comment_list_box:last-child { border-bottom: 0;}
    .admin_question_list_wrapper_box .question_list_box_desc_btn button.reply_del_btn { margin-top: 0; margin-left: 6px;}
    .admin_question_list_wrapper_box .question_list_box_desc_btn { margin-top: 10px;}
    .qna_check_box { height: 18px;}
    .qna_check_box input[type="checkbox"] { display: none;}
    .qna_check_box .label__on-off span { color: #fff;}
    .label__on-off {
      overflow: hidden;
      position: relative;
      display: inline-block;
      width: 34px;
      height: 18px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      border-radius: 20px;
      background-color: #7758fa;
      color: #fff;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      -ms-transition: all 0.3s;
      -o-transition: all 0.3s;
      transition: all 0.3s;
    }
    .label__on-off > * {
      vertical-align: sub;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      -ms-transition: all 0.3s;
      -o-transition: all 0.3s;
      transition: all 0.3s;
      font-size: 12px;
    }
    .label__on-off .marble {
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
      display: block;
      width: 12px;
      height: 12px;
      background-color: #fff;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      -webkit-box-shadow: 0 2px 4px 0 rgba(90, 90, 90, 0.5);
      -moz-box-shadow: 0 2px 4px 0 rgba(90, 90, 90, 0.5);
      box-shadow: 0 2px 4px 0 rgba(90, 90, 90, 0.5);
    }
    .label__on-off .on { padding-left: 12px; line-height: 25px; }
    .label__on-off .off { padding-left: 22px; line-height: 25px;}
    .input__on-off:checked + .label__on-off .off { display: inline-block;}
    .comment_list_box h4 span {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 15px;
      color: #666;
    }
    .comment_list_box_inner { margin-left: 10px; width: 100%;}
    .comment_list_box_inner pre { white-space: break-spaces;}
    .comment_write_box {
      display: none;
      background: #f7f7fa;
      padding: 10px 20px;
      box-sizing: border-box;
      border-radius: 6px;
      margin-top: 16px;
    }
    .comment_write_box_top { display: flex; align-items: center;}
    .comment_write_box_top h4 { margin-bottom: 0;}
    .comment_write_box_top p { font-size: 11px; line-height: 1.45; color: #999999; margin-left: 10px;}
    .comment_write_box img { vertical-align: text-bottom;}
    .comment_write_box.active { display: block;}
    .comment_write_box_flex { display: flex; justify-content: space-between; align-items: center;}
    .comment_write_box span {
      display: inline-block;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.54;
      color: #333333;
    }
    .comment_write_box textarea {
      font-size: 15px;
      width: 100%;
      height: 40px !important;
      border: none;
      background: none;
      margin-right: 10px;
      box-sizing: border-box;
      outline: none;
      color: #333;
      resize: none;
      font-family: "Noto Sans KR", sans-serif;
      height: auto;
      line-height: 1.63;
      border-bottom: 1px solid #ccc;
      padding: 6px 0;
    }
    .comment_write_box textarea::placeholder { font-size: 15px; text-align: left; color: #ccc;}
    .comment_write_box .comment_btn_box { display: flex;}
    .comment_write_box .comment_btn_box button {
      display: inline-block;
      width: 80px;
      height: 40px;
      line-height: initial;
      box-sizing: border-box;
      color: #fff;
      font-size: 15px;
      border-radius: 4px;
      background: #aaa;
      padding: 0;
    }
    .comment_write_box .comment_btn_box button.comment_btn_save { background: #7878a5; margin-left: 5px;}
    .detail_morebtn { text-align: center;}
    .detail_morebtn a {
      display: block;
      color: #666;
      padding: 9px 0;
      cursor: pointer;
      border: 2px solid #e7e7f9;
      border-radius: 4px;
    }
    /*==============QnA 끝=============*/
    

    /*=========콘솔페이지 배너============*/
    .slider_banner_box_con { position: relative; width: inherit; margin-bottom:30px;}
    .slider_banner_box_con .swiper-pagination { bottom: 0;}
    .slider_banner_box_con .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .slider_banner_box_con .swiper-pagination-bullet-active { background: #373779;}
    .slider_banner_box {
      width: inherit;
      height: auto;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }
    .slider_banner_box a { display: block; width: 100%; height: 100%;}
    .slider_banner_box img { width: 100%; height: 100%; display: block;}
    .slider_banner_box_con_empty{display:none;}
    /*=========콘솔페이지 배너 끝============*/

    /*=========콘솔페이지 파일, 안내 , 문의===========*/
    .detail_free_box,.detail_file_box { margin-bottom:30px; border-bottom: 1px solid #eee; padding-bottom: 30px; padding-right:10px;}
    .detail_free_box:last-child { border-bottom: 0;}
    .detail_free_box .title { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;}
    .detail_free_box h3,detail_file_box h3 { font-size: 20px; color: #333; font-weight: bold; line-height:20px;}
    .detail_free_box h3 img { vertical-align: middle; cursor: pointer; padding-bottom: 2px;}
    .detail_free_content img { display: inline-block; margin-right: 5px;}
    .detail_free_content p { color: #333; line-height: 1.63; white-space: break-spaces;}
    .detail_file_box .detail_file_inner_box h3,
    .detail_guide_box .detail_guide_inner_box h3{ font-size: 20px; color: #333; margin-bottom: 20px; font-weight: bold;}
    .detail_file_box .detail_file_inner_box h4 {
      font-size: 15px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #333333;
      margin-bottom: 8px;
    }
    .detail_file_box .detail_file_inner_box h4 a { color: #333 !important; }
    .detail_file_box .detail_free_content { margin-bottom: 20px;}
    .detail_guide_box{padding-right:10px}
    .detail_guide_inner_box p{line-height:1.7;}
    /*=========콘솔페이지 파일, 안내 , 문의 끝===========*/

    /*============채팅게시판=============*/
    .chat_container { background: #f7f7fa; border-radius: 6px;}
    .chat_container h2 {
      font-size: 20px;
      padding: 20px;
      color: #333333;
      font-weight: bold;
      line-height: normal;
    }
    .chat_container .chat_content {
      padding: 20px;
      height: 580px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
      background: #ededf7;
      overflow-y: auto;
    }
    .chat_container .chat_content p { margin-bottom: 20px;}
    .chat_container .chat_content p:last-child { margin-bottom: 0;}
    .chat_container .chat_content p span {
      display: inline-block;
      padding: 8px;
      line-height: 1.63;
      letter-spacing: normal;
      text-align: left;
      color: #666666;
      border-radius: 6px;
      box-shadow: 3px 6px 12px 0 #eeeeee;
    }
    .chat_container .chat_content p span div {font-size: 15px; line-height: 1.54; word-break: break-all;}
    .chat_container .chat_content p.other_write strong {
      display: block;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.85;
      text-align: left;
      color: #4e4b7b;
      margin-bottom: 8px;
    }
    .chat_container .chat_content p.other_write span { background: #fff; margin-bottom: 6px;}
    .chat_container .chat_content p.other_write small { display: block; font-size: 11px; line-height: 1.45; color: #999999;}
    .chat_container .chat_content p.my_write { display: block; width: 100%; text-align: right;}
    .chat_container .chat_content p.my_write strong { display: none;}
    .chat_container .chat_content p.my_write span { display: inline-block; background: #dbdbeb; margin-bottom: 6px;}
    .chat_container .chat_content p.my_write small { display: block; font-size: 11px; line-height: 1.45; color: #999999; }
    .chat_container .chat_write { display: flex; align-items: flex-end; padding: 20px; justify-content: space-between;}
    .chat_container .chat_write .chat_write_box_inner { display: none;}
    .chat_container .chat_write textarea {
      display: block;
      resize: none;
      width: calc(100% - 90px);
      border: none;
      background: none;
      background: #f7f7fa;
      font-family: "Noto Sans KR", sans-serif;
      color: #666;
      font-size: 15px;
      padding: 10px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ccc;
    }
    .chat_container .chat_write textarea::placeholder { color: #ccc;}
    .chat_container .chat_write button { background: #7878a5; color: #fff; padding: 10px 20px; border-radius: 4px; }
    /*============콘솔페이지 채팅게시판 끝=============*/
    
    
    /*===========프로필 모달창============*/
    /*=============speaker_profile=================*/
    .speaker_profile_container .close_btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      background: none;
      cursor: pointer;
      padding: 0;
    }
    .speaker_profile_container .close_btn.m_width_close_btn,
    .m_width_inform_text{display:none;}
    .profile_img {
      position: relative;
      width: 240px;
      background: rgba(0, 0, 0, 0.3);
      overflow: hidden;
    }
    
    .profile_img img.profile_image {
      width: 162px;
      height: 162px;
      display: block;
      margin: 70px auto 15px;
      z-index: 9999;
      border-radius: 50%;
      background-color:#D0D0DE;
    }
    .profile_img img.background_img {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      -webkit-filter: blur(60px);
      -moz-filter: blur(60px);
      -o-filter: blur(60px);
      -webkit-filter: blur(60px);
      filter: blur(60px);
      backdrop-filter: blur(60px);
      z-index: -1;
      min-width:300px;
      min-height:900px;
    }
    .profile_img .profile_content pre { font-family: "Noto Sans KR", sans-serif;}
    .profile_img .profile_content_top_text { margin:0 35px;}
    .profile_img .profile_content_top_text h2 {
      font-size: 20px;
      color: #fff;
      margin-bottom: 10px;
      word-break: break-all;
    }
    .profile_img .profile_content_top_text p {
      font-size: 13px;
      line-height: 1.63;
      color: #fff;
      word-break: break-all;
    }
    .profile_content { width: calc(100% - 240px); background: #fff; }
    .profile_content_top { display: flex; justify-content: space-between; padding: 20px; }
    .profile_content_top h2 {
      font-size: 26px;
      font-weight: 900;
      color: #111111;
      line-height: initial;
    }
    .profile_content_mid {
      padding: 20px 35px;
      max-height: calc(100% - 77px);
      overflow-y: auto;
      width: 100%;
    }
    .profile_content_mid table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .profile_content_mid table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    .profile_content_mid h3 { font-size: 18px; font-weight: bold; color: #333333; margin-bottom: 10px;}
    .profile_content_mid p { line-height: 1.63; color: #666666;}
    .profile_content_mid pre {
      font-family: "Noto Sans", sans-serif;
      width: 100%;
      white-space: break-spaces;
      font-size: 15px;
      line-height: 1.63;
      letter-spacing: normal;
      color: #666666;
    }
    .m_profile_content_top { display: none; }
    
    @media (max-width: 1023px) {
      .detail_flex_box { display: block;}
      .detail_left_box { width: 100%; padding-right: 0;}
      .detail_left_box_top {padding-left: 0; }
      .detail_right_box { width: 100%; margin-top: 30px;}
      .slider_banner_box_con { width: 100%; }
    }
    
    /*===========프로필 모달창 모바일==============*/
    @media (max-width: 767px) and (orientation: portrait) {
      .profile_content_top { display: none; }
      .m_profile_content_top { display: flex; align-items: center; justify-content: space-between; padding:20px; }
      .m_profile_content_top h2 { font-size: 18px; color: #fff;}
      .m_profile_content_top .close_btn .line { background: #fff;}
      .speaker_profile_container {
        position: unset;
        top: auto;
        left: auto;
        transform: unset;
        width: 100%;
        flex-direction: column;
        min-height: auto;
        max-height: 100%;
        border-radius: 0;
      }
      .speaker_profile_container .close_btn { position: absolute; top: 10px; right: 10px;}
      .m_profile_flex{display:flex; align-items:flex-start; height:calc(100% - 61px); padding:0 20px; overflow:auto; gap:20px;}
      .profile_img {
        width: 100%;
        box-sizing: border-box;
        height: 100%;
        max-height: 240px;
        padding-bottom:20px;
      }
      .profile_img img.profile_image { width: 100px; height: 100px; margin:0;}
      .profile_img img.background_img { top: 20%; }
      .profile_img .profile_content_top_text { text-align:left; margin:0;}
      .profile_content {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        height: calc(100vh - 240px);
        overflow-y: auto;
      }
      .profile_content_mid { margin-bottom: 0; padding: 0; max-height: 100%; overflow-y: unset;}
      .profile_content_mid > div{padding-bottom:20px;}
      .profile_content_mid pre { padding: 20px;}
    }
    /*=====프로필 모달창 모바일 가로모드====*/
    @media (max-width: 950px) and (max-device-height: 500px){
      .profile_content_top{display:none;}
      .m_profile_flex{
        overflow-y: auto;
        height: 100%;
      }
      .m_width_inform_text{
        display:block;
        margin: 0 auto;
        margin: 20px 0 0 20px;
        font-size: 20px;
        color: #fff;
        text-align: left;
      }
      .m_width_close_btn{display:block;}
      .profile_content_mid{padding: 20px 50px 20px 20px; height: calc(100vh - 50px);}
      .speaker_profile_container .close_btn.m_width_close_btn{display:block; right:10px;}
      .profile_img img.profile_image{width:120px; height:120px; margin:10px auto 15px;}
      .profile_img .profile_content_top_text{text-align:center;}
    }
    /*==========admin Notice 게시판=============*/
    .admin_notice_container {
      display: none;
      width: 100%;
      padding: 10px;
      background: #f7f7fa;
      border-radius: 4px;
    }
    .admin_notice_container.on {
      display: block;
    }
    .detail_notice_free_content.on {
      display: none;
    }
    .admin_notice_container_inner {
      width: 100%;
      height: 100%;
    }
    .admin_notice_container_inner textarea {
      font-family: "Noto Sans KR", sans-serif;
      width: 100%;
      min-height: 210px;
      box-sizing: border-box;
      resize: vertical;
      border: none;
      line-height: 1.63;
      color: #666666;
      background: #f7f7fa;
    }
    .admin_notice_container_inner textarea::placeholder {
      font-size: 15px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }
    .ad_notice_button_box { display: none; justify-content: center;}
    .ad_notice_button_box button {
      padding: 0;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.71;
      text-align: left;
      color: #333;
    }
    .ad_notice_button_box.on { display: flex;}
    .ad_notice_button_box .ad_notice_cancel { color: #333333; margin-right: 8px;}
    .ad_notice_button_box .ad_notice_cancel:after {
      content: "";
      display: inline-block;
      width: 1px;
      height: 10px;
      background: #ccc;
      margin-left: 8px;
    }
    .ad_notice_button_box .ad_notice_save { color: #6a6af8; }
    
    /*===========미디어쿼리==============*/
    @media (min-width: 767px) {
      .m_detail_guide_box { display: none;}
    }
    /*=========콘솔페이지 메인 태블릿===========*/
    @media (min-width: 568px) and (max-width: 767px) {
      .detail_header_bnr {
        height: 380px;
      }
    }

    
    /*=========콘솔페이지 메인 모바일===========*/
    @media (max-width: 767px) and (orientation: portrait) {
      .section-content,.detail_con{ padding: 0;}
      .detail_header_bnr { position: sticky; display: block; height: 60px; z-index: 99;}
      .detail_header_bnr img { height: 100%;}
      .sub_bg_img_hd {
        position: fixed;
        top: 0;
        left: 0;
        min-height: 124px;
        height: 124px;
        margin: 0 auto;
      }
      .sub_bg_img_hd img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 0 20px;
      }
      .sub_bg_img_hd h1 {
        position: absolute;
        bottom: 10px;
        left: 20px;
        font-size: 32px;
        font-weight: 900;
        text-align: left;
        color: #111111;
      }
      
    
      /*========video container 모바일=========*/
      .video_con {
        position: sticky;
        top: 86px;
        width: 100%;
        z-index: 999;
        border-radius: 0;
      }
      .video_con.m_fixed {
        /* sticky를 fixed로 강제 — sticky는 부모(.detail_wrap) 영역 안에서만 동작하므로
           페이지 끝까지 스크롤하면 부모와 함께 viewport 위로 사라지는 회귀 방지. */
        position: fixed;
        top: 86px;
        left: 0;
        right: 0;
        width: 100%;
        display: flex;
        align-items: center;
        background: #fff;
        padding: 20px;
        min-height: auto;
        border-bottom: 1px solid #eae8e9;
      }
      .video_con.m_fixed .video_element { margin-right: 20px;}
      .video_con.m_fixed .video_info { display: block;}
      .video_con.m_fixed .video_info h4{margin-bottom: 10px;}
      .video_con.m_fixed .video_info h4 span{ font-size: 12px; font-weight: normal;}
      .video_con.m_fixed .video_info p {
        font-size: 15px;
        font-weight: bold;
        overflow: hidden;
        line-height: initial;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .video_con.m_fixed .video-frame { width: 120px;}
      .video_dummy.m_fixed { display: block;}
      .video_element {
        display: block;
        width: auto;
        border-radius: 0;
        overflow: unset;
      }
      .video_pre_con { border-radius: 0;}
    
      /*===========detail container 모바일=============*/
      .slide_con_flex{display:none;}
      .detail_flex_box { display: block; padding: 20px 20px 0 20px;}
      .detail_flex_box > div { width: 100%;}
      .detail_flex_box .m_detail_guide_box{ display:block; margin-top:30px; padding-right:0;}
      .detail_left_box { padding-right: 0; margin-bottom:20px; padding-top:0;}
      .detail_left_box_top { padding: 0; margin-bottom: 20px;}
      .livebtn,.ondemandbtn{margin-bottom:5px;}
      .detail_left_box_top > p {
        font-size: 20px;
        margin:0 0 20px;
        line-height: 1.4;
      }
      .detail_left_box_top .service_type_box{margin-bottom:5px;}
      .detail_left_box_top_inner { margin-bottom: 0;}
      .detail_left_box_top .more_btn_p { display: none;}
      .detail_left_box_top .more_btn_p.on { display: block; overflow: unset;}
      .detail_left_box_top .more_btn_span { margin-top: 0;}
      .m_slide_con{display:block;}
      .m_slide_con .swiper-container {
        margin-right: -20px;
        padding-right:20px;
        margin-bottom:0;
        padding-bottom:0;
      }
      .m_slide_con .swiper-slide{width:70%;}
      .m_slide_con .swiper-slide:last-child{padding-right:20px;}
      .m_slide_con .swiper-slide .slide_flex .slide_flex_div {
        position: relative;
        width: 58px;
        height: 58px;
        margin-right: 10px;
      }
      .m_slide_con .swiper-slide .slide_flex .slide_flex_inner_div { position: relative; width: 58px; height: 58px;}
      .m_slide_con .swiper-slide .slide_flex .slide_img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .m_slide_con .swiper-slide .slide_flex_t h2 { font-size: 15px; text-align: left; line-height: initial; color: #333;}
      .m_slide_con .swiper-slide .slide_flex_t p span {display: inline-block; font-size:11px;}
      .detail_left_box_top .more_btn { padding: 0;}
      .detail_right_box { display: none; width: 100%; margin-bottom: 30px; padding-top:0;}
      .detail_banner_box { width: 100%;}
      .slide_con_flex .slide_flex{width:fit-content;}
      .m_banner_box_swiper_box { display: block; position: static; margin-bottom: 50px;}
      .m_banner_box_swiper_box .swiper-container{height:120px;}
      .m_banner_box_swiper_box .swiper-container .swiper-slide{height:100%; border-radius: 6px; overflow: hidden;}
      .m_banner_box_swiper_box .swiper-container .swiper-slide a{display: block; height:100%}
      .m_banner_box_swiper_box .swiper-container .swiper-slide a img{ display: block; width: 100%; height:100%}
      .m_banner_box_swiper_box .swiper-container-horizontal > .swiper-pagination {bottom: 0px;}
      .m_banner_box_swiper_box .swiper-pagination-bullet {
        width: 12px;
        opacity: 1;
        height: 12px;
        background: #fff;
        border: 2px solid #373779;
        box-sizing: border-box;
      }
      .m_banner_box_swiper_box .swiper-pagination-bullet-active {background: #373779; }
      .m_detail_banner_box_con { display: block; }
      .m_detail_banner_box_con .right_banner_box a{display:block; font-size:0;}
      .m_detail_banner_box_con .right_banner_box a img{width:100%; height:auto;}
      .m_detail_banner_box_con .slider_banner_box {width: 100%;}
      .m_detail_content{display:block;}
      .m_list_wrapper { margin-bottom: 20px;}
      .m_list_wrapper ul { display: flex; justify-content: space-around;text-align: center;}
      .m_list_wrapper ul li {
        width: 100%;
        border-bottom: 1px solid #ccc;
        padding-bottom: 7px;
        cursor: pointer;
      }
      .m_list_wrapper ul li:hover,.m_list_wrapper ul li.active { border-bottom: 2px solid #111;}
      .m_list_wrapper li span {
        position: relative;
        display: block;
        font-size: 16px;
        font-weight: bold;
        color: #ccc;
      }
      .m_list_wrapper ul li:hover span,
      .m_list_wrapper ul li.active span {
        color: #111;
      }
      .detail_banner_box_con .right_banner_box{border-radius:8px; overflow:hidden;}
      .detail_banner_box_con .right_banner_box a,
      .detail_banner_box_con .right_banner_box a img{display:block; width:100%;}

      // .detail_banner_box_con{display:flex; gap:10px;}
      // .detail_banner_box_con > div,
      // .slider_banner_box_con,
      // .slider_banner_box_con_empty,
      // .detail_banner_box_con .right_banner_box{width:50%;}
      // .slider_banner_box_con{margin-bottom:0;}
      // .slider_banner_box_con_empty:last-child{display:none;}
      // .slider_banner_box_con_empty{display:block; background:#EBEBF8; border-radius:6px;}
    
      /*======= QnA 게시판 모바일=========*/
      .pc_qna_container { display: none; }
      .qna_container .detail_morebtn { padding: 0;}
      .qna_container .question_write_box { padding: 10px;}
      .qna_container .question_write_box input { display: none;}
      .qna_container .question_write_box textarea {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        box-sizing: border-box;
        outline: none;
        color: #333;
        border-radius: 0;
      }
      .qna_container .question_write_box button { width: 100%;}
      .qna_container .question_write_box .question_write_box_inner { margin-bottom: 4px;justify-content: flex-end; }
      .qna_container .question_write_box .question_write_box_inner h2 { display: none;}
      .qna_container .question_write_box .question_write_box_inner span { position: unset; bottom: unset; right: unset;}
      .qna_container .question_write_box .question_box_flex { flex-direction: column; }
      .question_list_box { padding: 10px;}
      .question_list_box_title { display: block; margin-bottom: 40px; padding: 0;}
      .question_list_wrapper_box { padding: 0; margin-bottom: 30px; }
      .question_list_inner_box { padding: 0; margin-left: 0;}
      .question_list_box_desc { padding: 10px 0;}
      .comment_list_box { margin-left: 10px; }
      .comment_list_box .question_list_box_desc_btn .reply_del_btn { margin-left: 0; }
      .comment_write_box.active { margin-bottom: 10px;}
      .comment_write_box_top { margin-bottom: 15px; justify-content: space-between;}
      .comment_write_box .comment_write_box_top h4 span { font-size: 15px;}
      .comment_write_box .comment_btn_box { width: 100%;}
      .comment_write_box_flex { flex-direction: column; padding-left: 0;}
      .comment_write_box textarea { margin-right: 0;}
      .comment_write_box .comment_btn_box button {
        font-size: 15px;
        width: 50%;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
      }

      @media (orientation: portrait) {
        .video_con.m_fixed ~ .detail_flex_box .m_qna_container {
          padding-top: 124px;
        }
      }
    
      /*==========공지사항,파일 게시판 모바일===========*/
      .detail_free_box,.detail_file_box { margin: 0; padding-bottom: 0; border-bottom: 0; padding-right:0;}
      .detail_free_box .title { margin-bottom: 15px; height: 20px;}
      .detail_free_inner_box .title h3 {
        display: flex;
        align-items: center;
        height: 20px;
        font-size: 15px;
        font-weight: bold;
        line-height: 1.71;
        color: #333333;
      }
      .detail_file_box h3 { display: none;}

      /*===========채팅 게시판 모바일=============*/
      .pc_chat_container { display: none; }
      .chat_container h2 { display: none;}
      .chat_container .chat_content { height: 370px; padding: 10px; border-radius: 6px;}
      .chat_container .chat_write { display: block;}
      .chat_container .chat_write .chat_write_box_inner { display: block; text-align: right; margin-bottom: 5px;}
      .chat_container .chat_write .chat_write_box_inner span { font-size: 11px; color: #999;}
      .chat_container .chat_write input { display: none; width: 100%; }
      .chat_container .chat_write textarea { width: 100%; margin-bottom: 10px; font-size: 15px;}
      .chat_container .chat_write button { width: 100%;}
      .admin_console { display: none; }

      /*안내 모바일*/
      .detail_file_box .detail_file_inner_box h3, .detail_guide_box .detail_guide_inner_box h3{font-size:15px;}
      .detail_guide_inner_box p{font-size:13px; color:#333;}
    }

    // @media all and (max-width:479px) {
    //   .detail_banner_box_con > div,
    //   .slider_banner_box_con > div,
    //   .slider_banner_box_con,
    //   .detail_banner_box_con .right_banner_box,
    //   .slider_banner_box_con_empty{width:100%;}
    //   .slider_banner_box_con_empty{display:none;}
    // }
    /*==============모달창=================*/
    /*=============로그인창 푸터 개인정보처리방침, 사이트이용약관==============*/
    .ft_modal_container {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 1180px;
      background: #fff;
      z-index: 99999;
      border-radius: 6px;
      overflow: hidden;
    }
    
    .ft_modal_header {
      background: #f8f8fe;
      padding: 20px;
      box-sizing: border-box;
    }
    .ft_modal_header > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .ft_modal_header h2 {
      font-size: 26px;
      font-weight: 900;
      line-height: 1.5;
      color: #111111;
    }
    .ft_modal_header p {
      font-size: 15px;
      line-height: 1.63;
      color: #666666;
      margin-top: 5px;
    }
    .ft_modal_content {
      line-height: 1.54;
      padding: 25px 30px;
      box-sizing: border-box;
      height: calc(100vh - 300px);
      background: #fff;
      color:#666;
      overflow-y: auto;
    }
    
    .ft_modal_content .session_subject {
      font-size: 20px;
      color: #333;
      font-weight: bold;
      line-height: 1.4;
      margin-bottom: 20px;
    }
    .modal_bg {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 9999;
    }
    .modal_bg.on {
      display: block;
    }
    
    /*========로그인창 푸터 개인정보처리방침, 사이트이용약관 모바일=============*/
    @media (max-width: 767px) and (orientation: portrait) {
      .ft_modal_container {
        width: 100%;
        top: 0;
        left: 0;
        transform: unset;
        max-height: none;
        height: 100%;
        border-radius: 0;
      }
    
      .ft_modal_header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        padding: 8px 20px;
        z-index: 999;
      }
      .ft_modal_header h2 {
        font-size: 18px;
      }
    
      .ft_modal_content {
        margin-top: 60px;
        padding: 20px;
        overflow-y: auto;
        height: calc(100% - 60px);
      }
    }
    
    
    /*-------서베이 모달창-------*/
    .survey_container .m_width_modal_footer,.m_width_wrap{display:none;}
    .survey_container {
      padding-left: 0;
    }
    .survey_container.modal.show .modal-dialog {
      transform: translate(-50%, -50%);
    }
    
    .survey_container .modal-dialog {
      width: 90%;
      max-width: 1180px;
      border-radius: 6px;
      margin: 0;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow:hidden;
    }
    .survey_container.modal.fade .modal-dialog {
      transform: translate(-50%, -50%);
    }
    .survey_container .modal-content {
      height: calc(100vh - 100px);
    }
    .survey_container .modal_header {
      background: #f8f8fe;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 6px 6px 0 0;
      display:flex;
      align-items:flex-start;
      justify-content:space-between;
      border-bottom: 1px solid #fff;
    }
    .survey_container .modal_header .modal_header_inner{ margin-right: 20px;}
    .survey_container .modal_title {
      font-size: 26px;
      font-weight: 900;
      line-height: normal;
      color: #111111;
      word-break: break-word;
      white-space: break-spaces;
    }
    .survey_container .modal_title div{font-size: 26px;}
    .survey_container .modal_header p {
      font-size: 13px;
      line-height: 1.63;
      color: #666666;
    }
    .survey_container .modal_header .close {
      font-size: 0;
      min-width: 40px;
      height: 40px;
      opacity: 1;
      background: url("https://cdn.onoffevent.com/common/icon_close.svg");
      padding: 0;
      margin: 0;
      cursor:pointer;
    }
    .survey_container .modal_header .close span { display: none; }
    .survey_container .modal_top_desc{padding: 10px 20px; background: #f8f8fe; word-break:break-word; white-space: break-spaces; color:#666; line-height:1.47;}
    .survey_container .modal_body {display: flex; flex-direction: column; background:#fff; padding: 0; height: calc(100vh - 145px); overflow-y: auto;}
    .survey_container .modal_body .submit_comfirm{text-align:center; display: flex; justify-content:center; align-items: center; height: auto; flex-direction: column; word-break:keep-all;word-wrap: break-word; padding: 0 20px;gap: 20px; margin: 140px 0; flex-grow: 1;}
    .survey_container .modal_body .submit_comfirm p{font-size: 26px; font-weight: bold; line-height: 1.5; color: #111;}
    .survey_container .modal_body .modal_page_desc{padding:20px; background:#fff; white-space: break-spaces; word-break: break-word; border-bottom: 1px solid #eeeeee;}
    .survey_container .modal_body .modal_page_desc table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .survey_container .modal_body .modal_page_desc table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;}
    .survey_container .modal_body .modal_page_desc h5{font-size: 15px; font-weight: bold; color: #333;}
    .survey_container .modal_body .modal_page_desc p{font-size: 15px; color: #666; }
    .survey_container .modal_body .modal_page_desc img,
    .survey_container .modal_body .modal_page_desc iframe,
    .survey_container .modal_body .modal_btm_desc img,
    .survey_container .modal_body .modal_btm_desc iframe{max-width:100%; }

    .survey_container .modal_body .form-group {padding: 20px 30px; margin-bottom: 0; border-bottom: 1px solid #eeeeee;}
    .survey_container .modal_body .form-group:last-child {border-bottom: 0;}
    .survey_container .modal_body .form-group .survey_question {color: #333; font-size: 16px; font-weight: bold; width: 100%; margin-bottom:20px; white-space: break-spaces; word-break: break-word;}
    .survey_container .modal_body .form-group .survey_choice {margin-left: 25px; color: #666666; word-break:break-word;}
    .survey_container .modal_body .form-group .errorMsg{display:flex; justify-content:center; align-items:center; background: rgba(239,50,50,0.1); margin-top:20px; padding: 12px; text-align: center; color: #ef3232; font-weight: bold;}
    .survey_container .modal_body .form-group .errorMsg span{display: inline-block; margin-left: 5px; padding-bottom: 3px; line-height: 20px;}
    .survey_container .modal_footer {
      display: flex;
      justify-content: space-between;
      border-radius: 0 0 6px 6px;
      background: #f8f8fe;
      min-height: auto;
      padding: 20px 30px;
    }
    .survey_container .modal_footer.m_width_modal_footer{display:none;}
    .survey_container .modal_footer button { border-radius: 4px; color: #fff; min-width: 142px; height: 48px; box-sizing: border-box; border: none; font-size: 16px;width:auto;}
    .survey_container .modal_footer button:first-child {background: #a5adb9;}
    .survey_container .modal_footer button:last-child {background: #6a6af8;}

    /*=========모달팝업 모달창===========*/
    /* z-index: 콘솔 팝업은 항상 서베이 모달(기본 1050) 아래로 — 동시 표시 시 서베이가 위에 노출되고 콘솔 팝업은 서베이 backdrop 아래에 가려짐 */
    .consolePopup_container.modal{z-index:1020;}
    .consolePopup_backdrop{z-index:1010;}
    .consolePopup_container .modal-content{max-height:calc(100vh - 100px); height:auto; min-height:120px; background:#fff; overflow:hidden;}
    .consolePopup_container > .modal-dialog > .modal-content > .modal_body{display:block; width:100%; background:#fff; padding:28px 32px; height:auto; min-height:120px; overflow-y:auto; overscroll-behavior:contain;}
    .consolePopup_container > .modal-dialog > .modal-content > .modal_body.console_popup_body_minimal{display:flex; align-items:center;}
    .consolePopup_container > .modal-dialog > .modal-content > .modal_body.console_popup_body_minimal > .modalInnerHtml{width:100%;}
    .consolePopup_container .modal-content .modalInnerHtml{font-size:16px; line-height:1.6; color:#111; word-break:break-word; white-space:break-spaces;}
    .consolePopup_container .modal-content .modalInnerHtml img,
    .consolePopup_container .modal-content .modalInnerHtml iframe,
    .consolePopup_container .modal-content .modalInnerHtml video,
    .consolePopup_container .modal-content .modalInnerHtml table{max-width:100%;}
    /*=========서베이 모달창 모바일===========*/
    @media (max-width: 767px), (orientation: landscape) and (max-width: 900px) and (max-device-height: 500px){
      .consolePopup_container .modal-content{max-height: 100%;}
      .survey_container .modal_content {
        height: 100%;
        border-radius: 0;
      }
      .survey_container.modal.fade .modal-dialog,
      .survey_container.modal.show .modal-dialog {
        transform: unset;
      }
      .survey_container .modal-dialog {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border-radius: 0;
        transform: unset;
      }
    
      .survey_container .modal_title div {
        font-size: 20px;
      }
      .survey_container .modal_header {
        padding: 16px 20px;
        border-radius: 0;
      }
      .survey_container .modal_header p {
        font-size: 12px;
        border-radius: 0;
      }
      .survey_container .modal_header .close {
        position: absolute;
        top: 13px;
        right: 10px;
      }
    
      .survey_container .modal_body {
        max-height: none;
      }
      /* 모바일 뷰포트에선 140px 상하 margin이 제출완료 이미지/문구를 화면 밖으로 밀어내므로
         flex 중앙정렬에 맡기고 margin 제거. */
      .survey_container .modal_body .submit_comfirm{margin:0; padding:20px;}
      .survey_container .modal_body .submit_comfirm p{font-size:20px;}
      .survey_container .modal_body .submit_comfirm img{max-height:120px;}
      .survey_container .modal_body .form-group {
        padding: 10px 20px;
      }
      .survey_container .modal_body .form-group .survey_choice {
        margin-left: 30px;
      }
      .survey_container .modal_body .form-group .survey_choice textarea {
        width:100% !important;
      }
    
      .survey_container .modal_footer {
        min-height: unset;
        border-radius: 0;
        padding: 10px 15px;
      }
      .survey_container .modal_footer button {
        width: calc(50% - 10px);
      }
      .survey_container .modal_footer button.btn-secondary {
        margin-right: 20px;
      }
      .survey_container .modal_footer button.btn-primary {
        margin-right: 5px;
      }
      .survey_container .modal_footer > * {
        margin: 0;
      }
      .consolePopup_container .modal_header .close{position:unset; top:unset; left:unset;}
    }

    /*--서베이 모달창 모바일 가로모드--*/
    @media (max-width: 900px) and (max-device-height: 500px){
      .survey_container .modal-content{flex-direction:row; height:100%;}
      .survey_container .modal_header{width:200px; height: 100%; overflow-y: auto; white-space: break-spaces; word-break: break-word;}
      .survey_container .modal_header .close {top:10px; right:10px; background-color: #f6f6fe; border-radius: 50%;}
      .survey_container .modal_title div{font-size:20px;}
      .survey_container .modal_header p{font-size:15px; color:#333;}
      .survey_container > .modal-dialog > .modal-content > .modal_body{display:none;}
      .survey_container .m_width_wrap{width:calc(100% - 200px); display:block;}
      .survey_container .m_width_wrap .modal_body{display:flex; flex-direction:column; height:100%;}
      /* height:calc(100% - 100px) + img 사이즈 무제한 조합으로 모바일 landscape에서 콘텐츠가 화면 밖으로 밀려남.
         flex 중앙정렬이 이미 있어서 height 100% 고정 해제하고 이미지는 작게 제한. */
      .survey_container .m_width_wrap .modal_body .submit_comfirm{display: flex; text-align: center; justify-content: center; align-items: center; height:100%; flex-direction: column; word-break: keep-word; padding: 10px 20px; gap:10px;}
      .survey_container .m_width_wrap .modal_body .submit_comfirm img{max-height:80px;}
      .survey_container .m_width_wrap .modal_body .submit_comfirm p{ font-size: 16px; font-weight: bold; line-height: 1.5; color: #111; margin-top:0;}
      .survey_container .m_width_wrap .modal_top_desc{ padding:20px;}
      .survey_container .modal_top_desc_pc_mobile,.survey_container .modal_footer{display:none;}
      .survey_container .modal_footer.m_width_modal_footer{display:flex; background:#fff;}
    }
     /*--콘솔팝업 모달창 모바일 가로모드--*/
    @media (max-width: 900px) and (max-device-height: 500px){
      .consolePopup_container .modal-content{flex-direction: column;}
      .consolePopup_container .modal_header{ width: 100%; overflow-y:unset;}
      .consolePopup_container > .modal-dialog > .modal-content > .modal_body{
        display:block; width:100%;
      }
    }
    /*--상담신청 모달창--*/
    /*--공통--*/
    
    .counsel_modal_animaition-enter {transform: translate(-50%,100%);}
    .counsel_modal_animaition-enter-active {transition: transform 0.5s; transform: translate(-50%,0%);}
    .counsel_modal_animaition-enter-done{transition: transform 0.5s; transform: translate(-50%,0%);}
    .counsel_modal_animaition-exit {transform: translate(-50%,0%); transition: transform 0.5s;}
    .counsel_modal_animaition-exit-active {transform: translate(-50%,100%); transition: transform 0.5s;}
    .counsel_modal_animaition-exit-done{transform: translate(-50%,100%); transition: transform 0.5s;}
    .counsel_modal_container{position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); z-index: 9999;}
    .counsel_modal{ position: fixed; bottom: 0; left: 50%; width: 600px; height: calc(100vh - 60px); background: #fff; z-index:99999; border-radius:6px 6px 0 0; max-width:100%;}
    .counsel_modal_header{ display:flex; align-items: center; justify-content: space-between; margin: 0px auto 0px; padding: 30px 30px 20px;}
    .m_counsel_modal_close{display:none;}
    .counsel_modal_header h1{ font-size: 28px; font-weight: bold; text-align: left; color: #333;}
    
    .counsel_modal_header_content span{ font-size: 15px; font-weight: normal; line-height: 1.69; text-align: left; color: #666; display:block; word-break: keep-all;}
    .counsel_modal_overflowY{overflow-y: auto; max-height: calc( 100vh - 223px );}
    .counsel_modal_mid h2{ font-size: 15px; font-weight: bold; line-height: 1.85; text-align: left; color: #4e4b7b;}
    .counsel_modal_inner_flex{ display:flex; align-items:center; justify-content:space-between;}
    .counsel_modal_inner_flex span{ position:relative; font-size: 15px; line-height: 2; text-align: left; color: #666; text-decoration:underline; cursor:pointer;}
    .counsel_modal_inner_flex span.today_before:before{ content:""; display:block; width:4px; height:4px; border-radius:100%; background:#111; position:absolute; top:50%; left:-10px; transform:translateY(-50%);}
    .counsel_modal_mid_inner{ position:relative; padding:20px 30px; border-bottom:1px solid #eeeeee;}
    .counsel_modal_mid_inner.show .arrow_imgbox{ transform: rotate(90deg); transition:all 0.3s;}
    .counsel_modal_mid_inner:last-child{ border-bottom:none; }
    .counsel_modal_mid_inner p{font-size: 15px; line-height: 2; text-align: left; color: #666;}
    .counsel_modal_bottom{ position: fixed; bottom: 0; width: 100%; left: 0; background: #f8f8fe;}
    .counsel_modal_bottom_btn{display: flex; padding: 10px 30px;}
    .counsel_modal_bottom_btn button{ width: 100%; height: 48px; color: #fff; background: #6a6af8; border-radius: 4px; font-size: 16px; font-weight: 600; line-height: 1.5;}
    .counsel_modal input[id="service_agree"], .counsel_modal input[id="privacy_agree"] { display: none;}
    .counsel_modal input[id="service_agree"] + label span{ display: inline-block; width: 24px; height: 24px; background: url("${ChkIcon}");
      background-repeat:no-repeat; cursor: pointer; vertical-align: text-bottom; margin-right: 5px;}
    .counsel_modal input[id="service_agree"]:checked + label span { background: url("${ChkOnIcon}"); }
    .counsel_modal .privacy_agree_box_inner label, .counsel_modal .service_agree_box_inner label{ display:flex; align-items:center; font-weight:bold; color: #4e4b7b;}
    .counsel_modal .privacy_agree_box_inner label b, .counsel_modal .service_agree_box_inner label b{ display:inline-block; }
    .privacy_agree_box{ margin-bottom:30px;}
    .privacy_agree_inner_textbox,.service_agree_inner_textbox{ background:#f7f7fa; padding:5px; box-sizing:border-box; height:75px; overflow-y:auto;}
    .privacy_agree_inner_textbox.active{ height:auto; }
    .privacy_agree_inner_textbox p, .service_agree_inner_textbox p{ font-size: 15px; line-height: 1.69;}

    /*counsel_modal_inner1*/
    .counsel_modal_inner1 .counsel_modal_mid{ padding:0 30px;}
    .counsel_modal_inner1 .counsel_modal_header_content{ margin-bottom:35px; padding:0 30px;}
    .counsel_modal_inner1 .counsel_modal_mid h2{ margin-bottom:10px;}
    .counsel_modal_inner1 .counsel_modal_mid textarea{ width:100%; min-height:140px; border-color:#ccc; margin-bottom:70px; resize: vertical;}
    .counsel_modal_inner1 .counsel_modal_mid .counsel_modal_mid_img{ max-height:400px; overflow:hidden;}
    .counsel_modal_inner1 .counsel_modal_mid img { display: block; margin:0 auto;}

    /*counsel_modal_inner2*/
    .counsel_modal_inner2 .counsel_modal_header_content{ border-bottom: 1px solid #eeeeee; padding: 0 30px 25px;}
    .counsel_modal_inner2 .counsel_modal_inner_flex{ display:flex; align-items:center; justify-content:space-between; margin-bottom:10px;}
    .counsel_modal_inner2 .time_select_container{
      position:relative;
      display: flex;
      width:100%;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      background: #f7f7fa;
      border-radius: 4px;
      margin-top: 10px;
    }
    .counsel_modal_inner2 .time_select_container span{
      font-size: 15px;
      line-height: 1.69;
      text-align: left;
      color: #666;
    }
    .counsel_modal_inner2 .time_select_container .arrow_imgbox{
      width: 28px;
      height: 28px;
      position: relative;
      background: #fff;
      box-shadow: 0px 3px 3px #efefef;
      border-radius: 6px;
      cursor:pointer;
      transition:all 0.3s;
    }
    .counsel_modal_inner2 .time_select_container .arrow_imgbox img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      display: block;
    }
    .counsel_modal_inner2 .counsel_modal_bottom_btn button:first-child{
      margin-right:10px;
      background:#a5adb9;
    }
    /**/
    .time_select_box{
      width: calc( 100% - 60px);
      margin: 5px 25px 0;
      border: 1px solid #4e4b7b;
      border-radius: 4px;
      padding: 0;
      overflow:hidden;
    }
    .time_select_box li{
      padding:10px 12px;
      font-size: 15px;
      font-weight: 500;
      line-height: 2;
      text-align: left;
      color: #333;
      cursor:pointer;
    }
    .time_select_box li:hover{
      background:#e7e7f9;
    }
    /*counsel_modal_inner3*/
    .counsel_modal_inner3 .counsel_modal_mid_inner{
      border-bottom:none;
      padding:0 30px 30px;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner:first-child{
      text-align:center;
      margin:100px auto 80px;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner:first-child img{
      display:block;
      margin: 0 auto 6px;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner h5{
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      color: #333;
      width: 295px;
      margin: 0 auto;
      line-height: normal;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner1{
      padding: 0 0px 20px 0px;
      border-bottom:2px solid #111111;
      margin:0 30px;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner1 h4{
      font-size: 15px;
      font-weight: bold;
      line-height: 1.54;
      text-align: left;
      color: #333;
      margin-bottom:10px;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner1 > p{
      font-size: 15px;
      line-height: 2;
      text-align: left;
      color: #333;
      margin-bottom:10px;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner1 > div > h4{
      margin-bottom:0;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner2 p {
      line-height: 2.15;
      text-align: left;
      color: #333;
      margin:20px 0;
    }
    .counsel_modal_inner3 .counsel_modal_mid_inner2 span{
      line-height: 2;
      color: #666;
    }
    .counsel_modal_inner3 .counsel_modal_bottom_btn button:first-child,
    .counsel_modal_inner3 .counsel_modal_bottom_btn button:nth-child(2)
    {
      background:#a5adb9;
      margin-right:10px;
    }
    /*신청취소시 경고창 애니메이션*/
    .cancel_alert-enter {
      opacity: 0;
      
    }
    .cancel_alert-enter-active {
      opacity: 1;
      transition: opacity 300ms;
    }
    .cancel_alert-exit {
      opacity: 1;
    }
    .cancel_alert-exit-active {
      opacity: 0;
      transition: opacity 300ms;
    }
    .bg_fixed{position:fixed;
      top:0;
      left:0;
      width:100%;
      height:100%;
      background:rgba(0,0,0,0.8);
      z-index: 99999;
    }
    .cancel_alert_container{
      position:fixed;
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
      z-index:999999;
      width:320px;
      height:130px;
      border-radius:6px;
      padding:20px;
      background:#fff;
    }
    .cancel_alert_container h2{
      font-size: 15px;
      line-height: 1.69;
      text-align: left;
      color: #666;
      margin-bottom:30px;
    }
    .cancel_alert_container > div{
      text-align:center;
    }
    .cancel_alert_container button{
      width:100px;
      color:#fff;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
      margin-right:10px;
      border-radius: 4px;
      text-align:center;
      padding:8px 0;
      background-color: #a5adb9;
    }
    .cancel_alert_container button:last-child{
      margin-right:0px;
      background-color: #6a6af8;
    }
    /*--counsel_modal_inner3--*/
    .counsel_modal_inner3 .counsel_modal_header_content{
      padding: 0 30px 25px;
    }
    /*counsel_modal_inner4*/
    .counsel_modal_inner4 .counsel_modal_mid_inner textarea{
      width:100%;
      min-height:80px;
      resize:vertical;
      border:1px solid #ccc;
      padding:10px;
      font-size: 15px;
      line-height: 1.69;
      color: #666;
    }
    .counsel_modal_inner4 .counsel_modal_mid_inner_input_box input{
      width:100%;
      height:40px;
      display:block;
      border:none;
      border-bottom:1px solid #ccc;
      color:#666;
      font-size: 15px;
      line-height: 2;
      text-align: left;
      margin-bottom:10px;
    }
    .counsel_modal_inner4 .counsel_modal_mid_inner_input_box input:last-child{
      margin-bottom:0;
    }
    .counsel_modal_inner4 .counsel_modal_mid_inner_input_box input::placeholder{
      color:#ccc;
    }
    .counsel_modal_inner4 .counsel_modal_mid_inner_input_box > div > input{
      border-color:#7758fa;
    }
    .counsel_modal_inner4 .counsel_modal_mid_inner_input_box > div > img{
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      cursor: pointer;
    }
    /*counsel_modal_inner5*/
    .counsel_modal_inner3 .counsel_modal_mid_inner:first-child{
      margin:70px auto 100px;
    }
    .counsel_modal_inner5 .counsel_modal_header_content small{
      margin-top: 20px;
      display: inline-block;
      font-size: 15px;
      line-height: 2;
      color: #111;
      text-decoration: underline;
    }
    .counsel_modal_inner5 .counsel_modal_header_content{
      width:100%;
    }
    .counsel_modal_inner5 .counsel_modal_bottom_btn button:first-child{
      background: #6a6af8;
      margin-right:0;
    }
    /*calendar_container*/
      .m_calendar_container{display:block; cursor:ew-resize;}
      #slide_test2{
        width:100%;
        overflow-x:auto;
        padding:10px 0;
      }
      #slide_test2{ -ms-overflow-style: none; }
      #slide_test2::-webkit-scrollbar{ display:none; }
      .m_calendar_container .swiper-slide{ width:auto; font-size:0px; }
      .m_calendar_container .swiper-slide span{ position:sticky; left:0; z-index:999; font-size:11px; color:#fff; }
      .m_calendar_container .swiper-slide span,
      .m_calendar_container .swiper-slide .select_m{ display:inline-block; border-radius:100%; text-align:center;  vertical-align:middle}
      .m_calendar_container .swiper-slide span{ width:28px; height:28px; background:#b9b9b9; line-height:28px;  }
      .m_calendar_container .swiper-slide .select_m:nth-child(2) {margin-left:16px;}
      .m_calendar_container .swiper-slide .select_m{
        position:relative;
        width: 62px;
        height: 62px;
        background: #f7f7fa;
        margin-right: 16px;
      }
      .m_calendar_container .swiper-slide .select_m.select_today:before{
        content:"";
        display:block;
        width:4px;
        height:4px;
        background:#111;
        border-radius:50%;
        position:absolute;
        top:-10px;
        left:50%;
        transform:translateX(-50%);
      }
      .m_calendar_container .swiper-slide .select_m div{
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
      }
      .m_calendar_container .swiper-slide .select_m div small{
        display:block;
        font-size: 11px;
        line-height: 11px;
        text-align: center;
        color: #666;
      }
      .m_calendar_container .swiper-slide .select_m div b{
        display:block;
        font-size: 22px;
        font-weight: 500;
        line-height:1;
        color: #666;
      }
      .m_calendar_container .swiper-slide .select_m.active{
        background:#7758fa;
      }
      .m_calendar_container .swiper-slide .select_m.active b,
      .m_calendar_container .swiper-slide .select_m.active small{
        color:#fff;
      }
    .calendar_container{padding: 0 30px;}
    .m_calendar_container{display:block;}
    .calendar_container .swiper-container{
      padding: 10px 30px;
      position:static;
    }
    .calendar_container .swiper-slide{
      width: 62px;
      height: 62px;
      border-radius: 50%;
      background: #f7f7fa;
      text-align: center;
      cursor:pointer;
    }
    .calendar_container .swiper-slide-active{
      background:#7758fa;
    }
    .calendar_container .swiper-slide > div{
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
    }
    .calendar_container .swiper-slide small{
      display:block;
      font-size: 11px;
      line-height: 11px;
      color: #666;
    }
    .calendar_container .swiper-slide b{
      display:block;
      font-size: 22px;
      font-weight: 500;
      color: #666;
      line-height:1.3;
    }
    .calendar_container .swiper-slide-active small,
    .calendar_container .swiper-slide-active b{
      color:#fff;
    }
    .calendar_container .swiper-slide.month{
      width:28px;
      height:28px;
      background:#b9b9b9;
      margin-top:16px;
    }
    .calendar_container .swiper-slide.month span{
      font-size:10px;
      color:#fff;
      line-height:28px;
    }
    .calendar_container .swiper-slide.today:before{
      content:"";
      display:block;
      width:4px;
      height: 4px;
      border-radius:50%;
      background:#111;
      position:absolute;
      top:-10px;
      left:50%;
      transform:translateX(-50%);
    }
    .calendar_container .swiper-button-prev{
      position:absolute;
      background:url("https://cdn.onoffevent.com/common/icon_s_linkarw.svg") no-repeat;
      opacity:1;
      left: 30px;
      width: 28px;
      height: 28px;
      top: 50%;
      margin-top: 0;
    }
    .calendar_container .swiper-button-next{
      position:absolute;
      background:url("https://cdn.onoffevent.com/common/icon_s_linkarw.svg") no-repeat;
      opacity:1;
      right: 30px;
      width: 28px;
      height: 28px;
      top: 50%;
      margin-top: 0;
      transform:rotate(180deg);
    }
    .calendar_container .swiper-button-prev:after,
    .calendar_container .swiper-button-next:after{
      content:none;
    }
    /*--상담신청 모달창 모바일--*/
    @media (max-width: 767px) and (orientation: portrait) {
      .menu_call_box{
        position: absolute;
        top: 0;
        right: 75px;}
    }
    @media (max-width: 767px) and (orientation: portrait) {
      .menu_call_box{
        position: fixed;
        top: 0;
        right: 70px;
        height: 50px;
        padding: 12px 10px 0;
        transition: all 0.3s;
      }
      .menu_call_box span{font-size:15px;}
      /*-counsel_modal-*/
      .counsel_modal{
        position:fixed;
        border-radius:0;
        max-height: calc(100vh - 160px);
        height:100%;
      }
      .counsel_modal_header button{display:none;}
      .m_counsel_modal_close{
        display:block;
        position: absolute;
        top: -50px;
        left: 50%;
        transform:translateX(-50%);
        z-index: 99999;
      }
      .m_counsel_modal_close img{display:block;}
      .counsel_modal_header{
        padding:16px 20px 20px;
      }
      .counsel_modal_header h1{
        font-size: 20px;
        font-weight: 900;
        color: #333;
      }
      .counsel_modal_overflowY{
        max-height: calc( 100vh - 288px );
      }
      .counsel_modal_mid_inner{padding:20px 20px;}
    
      /*counsel_modal_inner1*/
      .counsel_modal_inner1 .counsel_modal_header_content{
        margin-bottom:20px;
        padding:0 20px;
      }
      .counsel_modal_inner1 .counsel_modal_mid{
        padding:0 20px;
      }
      .counsel_modal_inner1 .counsel_modal_mid textarea{
        margin-bottom:50px;
      }
      .counsel_modal_inner1 .counsel_modal_mid .counsel_modal_mid_img{
        max-height:300px;
        overflow:hidden;
        height:auto;
      }
      .counsel_modal_inner1 .counsel_modal_mid img{
        width:100%;
      }
      /*.time_select_box*/
      .time_select_box{
        width: calc( 100% - 40px);
        margin: 5px 15px 0;
      }
      /*counsel_modal_inner2*/
      .counsel_modal_inner2 .counsel_modal_header_content{
        padding:0 20px 20px 20px;
      }
      /*counsel_modal_inner3*/
      .counsel_modal_inner3 .counsel_modal_header_content{
        padding:0 20px 20px;
      }
      .counsel_modal_inner3 .counsel_modal_mid_inner{
        padding:0 20px 20px;
      }
      .counsel_modal_inner3 .counsel_modal_mid_inner h5{
        font-size:20px;
      }
      .counsel_modal_inner3 .counsel_modal_mid_inner1{
        margin: 0 20px;
        padding:0 0 20px 0;
      }
      .calendar_container{display:none;}
      .m_calendar_container{display:block;}
      #slide_test2{
        width:100%;
        overflow-x:auto;
        padding:10px 0;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
      }
      #slide_test2::-webkit-scrollbar{display:none;}
      .m_calendar_container .swiper-slide{ width:auto; font-size:0px; }
      .m_calendar_container .swiper-slide span{ position:sticky; left:0; z-index:999; font-size:11px; color:#fff; }
      .m_calendar_container .swiper-slide span,
      .m_calendar_container .swiper-slide .select_m{ display:inline-block; border-radius:100%; text-align:center;  vertical-align:middle}
      .m_calendar_container .swiper-slide span{ width:28px; height:28px; background:#b9b9b9; line-height:28px;  }
      .m_calendar_container .swiper-slide .select_m:nth-child(2) {margin-left:16px;}
      .m_calendar_container .swiper-slide .select_m{
        position:relative;
        width: 62px;
        height: 62px;
        background: #f7f7fa;
        margin-right: 16px;
      }
      .m_calendar_container .swiper-slide .select_m.select_today:before{
        content:"";
        display:block;
        width:4px;
        height:4px;
        background:#111;
        border-radius:50%;
        position:absolute;
        top:-10px;
        left:50%;
        transform:translateX(-50%);
      }
      .m_calendar_container .swiper-slide .select_m div{
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
      }
      .m_calendar_container .swiper-slide .select_m div small{
        display:block;
        font-size: 11px;
        line-height: 11px;
        text-align: center;
        color: #666;
      }
      .m_calendar_container .swiper-slide .select_m div b{
        display:block;
        font-size: 22px;
        font-weight: 500;
        line-height:1;
        color: #666;
      }
      .m_calendar_container .swiper-slide .select_m.active{
        background:#7758fa;
      }
      .m_calendar_container .swiper-slide .select_m.active b,
      .m_calendar_container .swiper-slide .select_m.active small{
        color:#fff;
      }
    }
    

    .question_storage_table {
      max-width: 1180px;
      margin: 0 auto;
      box-sizing: border-box;
      width:100%;
      table-layout: fixed;
    }
    .question_storage_table thead tr {
      text-align: center;
      line-height: 34px;
      
    }
    .question_storage_table thead tr th {
      position: relative;
      background: #f7f7fa;
      color: #4e4b7b;
      font-size: 13px;
      font-weight: bold;
    }
    .question_storage_table thead tr th span {
      position: absolute;
      top: 48%;
      transform: translateY(-50%);
      right: 30px;
    }
    .question_storage_table thead tr th span img:last-child {
      display: inline-block;
      margin-left: 1px;
    }
    .question_storage_table tbody tr {
      border-bottom: 1px solid #eeeeee;
    }
    .question_storage_table tbody tr td {
      padding: 20px;
      vertical-align: middle;
      color: #333;
      font-size: 13px;
      font-weight: normal;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    // @media (min-width:768px) and (max-width: 1023px){
    //   .detail_banner_box_con{display:flex; gap:10px;}
    //   .detail_banner_box_con > div{width:33.33%;}
    //   .slider_banner_box_con{margin-bottom:0;}
    //   .slider_banner_box_con_empty{display:block; background:#EBEBF8; border-radius:6px;}
    // }
  
  
  /*gsk 콘솔페이지*/
  #gsk_version .sch_b_con .session_name{margin-bottom:20px;}

  @media (max-width: 767px) and (orientation: portrait) {
  .detail_header_bnr,.sub_bg_img_hd{display:none;}
  }

  /*콘솔 출석 모달창*/
    #attendModal.modal-dialog {
      width: 80%;
      max-width: 460px;
      border-radius: 8px;
      margin: 0;
      padding: 12px 20px;
      position: fixed;
      background:#fff;
      box-shadow: 16px 16px 12px 0px rgba(0, 0, 0, 0.12);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow:hidden;
    }
    #attendModal.modal.show .modal-dialog,
    #attendModal.modal.fade .modal-dialog{  transform: translate(-50%, -50%); }
    #attendModal .modal-content{border:none;}
    #attendModal .attend_modal{display:flex; flex-direction:column; gap:8px;}
    #attendModal .attend_header{display:flex; justify-content:space-between; align-items:center;}
    #attendModal .attend_header h2{font-size: 18px; font-weight: 700; line-height: 22px; color:#1a1a1a;}
    #attendModal .attend_header button img{display:block;}
    #attendModal .attend_content{padding:12px; background:#F7F7FA; border-radius:6px; max-height: 200px; overflow-y: auto;}
    #attendModal .attend_footer{display: flex; align-items: center; gap: 4px; justify-content: center; padding:4px 0;}
    #attendModal .attend_footer button{min-width:120px; padding:6px 12px; box-sizing:border-box; border-radius:4px; border:1px solid #D7D7D7; color:#1a1a1a;font-size: 13px; font-weight: 500; line-height: 18px;}
    #attendModal .attend_footer button.confirm{background:#5959EF; border:1px solid #5959EF; color:#fff;}
    @media (max-width: 767px) and (orientation: portrait) {
      #attendModal .attend_footer button{width:50%;}
    }
  /*gsk 푸터 모달창*/
  #gsk_version .modal_container{
    position:fixed;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    max-width:700px;
    width:90%;
    background:#fff;
    padding:20px;
    border-radius: 6px;
    box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.2);
    z-index:999;
  }
  #gsk_version .modal_container .modal_close{
    display:block;
    margin-left: auto;
    height:40px;
    margin-bottom:10px;
  }
  #gsk_version .modal_container .modal_mid > h4{
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom:10px;
  }
  #gsk_version .modal_container .modal_mid > span{
    display:block;
    font-size: 13px;
    line-height: 1.69;
    text-align: left;
    color: #666;
    margin-bottom:30px;
  }
  #gsk_version .modal_container .btnBox{text-align:center;}
  #gsk_version .modal_container .modalBtn{width: 100px; height:40px; border-radius:4px; color:#fff; font-size: 13px;}
  #gsk_version .modal_container .cancelBtn{background-color: #a5adb9; margin-right:10px}
  #gsk_version .modal_container .confirmBtn{background-color: #6a6af8;}
  #footer .ft_modal_content table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    #footer .ft_modal_content table tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    .modal-backdrop {
      background:rgba(26, 26, 26, 0.60) !important;
      opacity:unset !important
    }
`
export default TypeAstyle;
